import React from 'react';
import PropTypes from 'prop-types';
import './Button.scss';

/**
 * Bouton réutilisable avec variants (primary, secondary, danger).
 * Accepte className pour conserver les styles spécifiques (ex. return-button).
 */
function Button({
  variant = 'primary',
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  const classNames = ['ui-button', `ui-button--${variant}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classNames} {...rest}>
      {children}
    </button>
  );
}

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'danger']),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Button;
